import {action, makeObservable, observable} from 'mobx';
import {trackModalOpen} from '../utils/posthog';

export default class ModalStore {
    constructor(organizationStore) {
        this.organizationStore = organizationStore;

        makeObservable(this, {
            stack: observable,
            addModal: action,
            clearAllModals: action,
            removeTop: action,
        });
    }

    stack = [];

    removeTop = () => {
        this.stack.pop();
    };

    addModal = (modalObj) => {
        this.stack.push(modalObj);

        const organizationId = this.organizationStore?.currentOrganization?.id || null;
        const modalProps = modalObj?.props ? Object.keys(modalObj.props) : undefined;

        trackModalOpen(modalObj.type, organizationId, {
            modal_type: modalObj.type,
            modal_props: modalProps,
            stack_depth: this.stack.length,
        });
    };

    clearAllModals = () => {
        this.stack.length = 0;
    };
}

